import React, {Component} from 'react';
import DataProperties from '../Properties/DataProperties'
import objeler from '../objeler';
import ModalBase from './ModaBase';
import store from '../../redux/store';

class ModalDialogData extends Component<props> {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
    }

    closeModal = (b) => {
        if (b !== "Cancel") {
            var orj = null;
            var pg = null
            var ob = [];
            var mx = Math.max(objeler.ModalDocParameters.DataSource.length, objeler.ModalDocValues.DataSource.length);
            console.log('max', mx)
            for (let i = 0; i < mx; i++) {
                if (i < objeler.ModalDocParameters.DataSource.length)
                    orj = objeler.ModalDocParameters.DataSource[i].title;
                if (i < objeler.ModalDocValues.DataSource.length)
                    pg = objeler.ModalDocValues.DataSource[i].title;
                if (orj != pg)
                    ob.push({"old": orj, "new": pg})
                orj = null;
                pg = null;
            }
            console.log('ob', ob)
            objeler.ModalDocParameters = {
                ...objeler.ModalDocValues,
                DataSource: JSON.parse(JSON.stringify(objeler.ModalDocValues.DataSource))
            };
            const objects = store.getState().appReducers.objects;
            for (let dt in ob) {
                for (let prp in objects) {
                    if (objects[prp].properties.DataSource == ob[dt].old)
                        objects[prp].properties.DataSource = ob[dt].new;
                }
            }
            objeler.ModalDocValues = {};
            objeler.closeModalData("dosya ismi");
        } else {
            objeler.ModalDocValues = {};
            objeler.closeModalData("Cancel");
        }
    }

    render() {
        // console.log('objeler.ModalDocParameters.FileName', objeler.ModalDocParameters)
        return (
            <div>
                {objeler.ModalDocParameters !== null && <ModalBase
                    isOpen={this.props.isOpen}
                    closeModal={this.closeModal}
                    title={'Datasource Properties'}
                >
                    <table className="ta ble" height="90%" style={{border: "2px"}}>
                        <tbody>
                        <tr>
                            <td scope="col" colSpan="3">
                                <DataProperties onDocChange={this.onDocChange}
                                                FileName={objeler.ModalDocParameters.FileName}
                                                DocProps={objeler.ModalDocParameters}></DataProperties>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </ModalBase>}
            </div>
        );
    }
}

export default ModalDialogData;